/**
 * Created by Mark on 18/04/2017.
 */


import ApplicationServices from './base-service.js';
import Constants from '../constants/authnetication.js';
import Action    from '../actions/default.js';

class SubscriptionService {

    constructor(){

    }

    getProducts(packageUid){
        return ApplicationServices.call(Constants.PRODUCTS , {packageUid:packageUid}).then(function(response){

            return response.response;
        });
    }

    vistPage(){
        return ApplicationServices.call(Constants.VIST_PRODUCTS , {}).then(function(response){
            return response;
        });
    }

}


export default new SubscriptionService();


// WEBPACK FOOTER //
// ./src/services/subscription-service.js